import { createSelector } from 'reselect';

export const bookmakersSwitcherSelector = ({ bookmakersSwitcher }) => bookmakersSwitcher || {};

export const redirectToLoginBookmakerSelector =
    createSelector(
        bookmakersSwitcherSelector,
        bookmakersSwitcher => (bookmakersSwitcher.info &&
            bookmakersSwitcher.info.redirectToLoginBookmaker) || null,
    );




// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/bookmakersSwitcher.selectors.js